<template>
    <div class="content">
        <div class="pageTitle">添加仓库</div>
        <div class="formArea">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="仓库编号:" prop="warehouse_sn">
                    <el-col :span="8">
                        <el-input v-model="form.warehouse_sn"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="仓库名称:" prop="warehouse_name">
                    <el-col :span="8">
                        <el-input v-model="form.warehouse_name" ></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="仓库地址:">
                    <el-col :span="8">
                        <el-input type="textarea" v-model="form.warehouse_address"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="负责人:">
                    <el-col :span="8">
                        <el-input v-model="form.principal" ></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="备注:">
                    <el-col :span="8">
                        <el-input type="textarea" v-model="form.remarks"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-col :span="8">
                        <el-button type="primary" @click="save('form')">保存</el-button>
                    </el-col>
                </el-form-item>

            </el-form>
        </div>
    </div>
</template>

<script>
    import { Message } from 'element-ui';
    export default {
        name: "addStock",
        data () {
            return {
                form: {
                    warehouse_sn:'',
                    warehouse_name:'',
                    warehouse_address:'',
                    principal:'',
                    remarks:''
                },
                rules: {
                    warehouse_sn: [
                        { required: true, message: '请输入仓库编号', trigger: 'blur' }
                    ],
                    warehouse_name: [
                        { required: true, message: '请输入仓库名称', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            getData(){
                let url  =  '/warehouses/' + this.$route.query.warehouse;
                this.$get('logistics',url, {
                }).then(res => {
                    if(res.message == '操作成功'){
                        this.form = res.data;
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            },
            save(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.$route.query.warehouse){
                            let url  =  '/warehouses/' + this.$route.query.warehouse;
                            this.$put('logistics',url, {
                                _method:'PUT',
                                lang:'',
                                warehouse_sn:this.form.warehouse_sn,
                                warehouse_name:this.form.warehouse_name,
                                warehouse_address:this.form.warehouse_address,
                                principal:this.form.principal,
                                remarks:this.form.remarks
                            }).then(res => {
                                console.log(res);
                                if(res.message == '操作成功'){
                                    this.$message({
                                        type: 'success',
                                        message: '修改成功!'
                                    });
                                    this.$router.push({
                                        name:'instockSetting'
                                    });
                                }
                            }).catch(function (error) {
                                console.log(error);
                            });
                            return false;
                        }
                        this.$post('logistics','/warehouses', {
                            lang:'',
                            warehouse_sn:this.form.warehouse_sn,
                            warehouse_name:this.form.warehouse_name,
                            warehouse_address:this.form.warehouse_address,
                            principal:this.form.principal,
                            remarks:this.form.remarks
                        }).then(res => {
                            console.log(res);
                            if(res.message == '操作成功'){
                                this.$message({
                                    type: 'success',
                                    message: '添加成功!'
                                });
                                this.$router.push({
                                    name:'instockSetting'
                                });
                            }
                        }).catch(function (error) {
                            Message.error(error)
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            }

        },
        created() {
            if(this.$route.query.warehouse){
                this.getData()
            }
        }
    }
</script>

<style scoped>

</style>